import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import Reducer, { initialState } from './Reducer';

const initializer = (initialValue = initialState) => initialValue;
  // JSON.parse(localStorage.getItem("global")) || initialValue;

const GlobalContext = React.createContext();

const Store = (props) => {
    const [store, dispatch] = useReducer(Reducer, initialState, initializer);

    useEffect(() => {
      try {
        localStorage.setItem("global", JSON.stringify(store));
      } catch (error) {
        console.error('Storage failed:', error.message);
      }
    }, [store]);

    return (
        <GlobalContext.Provider value={{ store, dispatch }}>
            {props.children}
        </GlobalContext.Provider>
    );
};

Store.propTypes = {
    children: PropTypes.element,
};

export { Store, GlobalContext };
